import React from 'react';
import TicketDetail from '@components/individualPortal/ticket/TicketDetail';

const TicketDetailContainer = (props) => {
    const {
        ticket
    } = props;

    return (
        <TicketDetail ticketData={ticket}/>
    );
};

export default TicketDetailContainer;

